(function () {
  const stateMap = {
    india: [
      "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu","Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"
    ],
    us: [
      "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"
    ],
    ca: [
      "Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador","Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon"
    ],
    au: [
      "Australian Capital Territory","New South Wales","Northern Territory","Queensland","South Australia","Tasmania","Victoria","Western Australia"
    ]
  };

  const countryCodeMap = {
    IN: { name: "India", dial: "+91" },
    US: { name: "United States", dial: "+1" },
    CA: { name: "Canada", dial: "+1" },
    AU: { name: "Australia", dial: "+61" }
  };

  const init = () => {
    const form = document.querySelector("#LiveVideoShoppingForm");
    if (!form) return;

    const phoneInput = form.querySelector("#LVSPhone");
    const countrySelect = form.querySelector("[data-country-select]");
    const stateSelect = form.querySelector("[data-state-select]");
    if (countrySelect && stateSelect) {
      const populateStates = () => {
        const key = countrySelect.selectedOptions[0]?.dataset.stateSource;
        const states = key ? stateMap[key] || [] : [];
        stateSelect.innerHTML = '<option value="">Select State</option>' + states.map((state) => `<option value="${state}">${state}</option>`).join("");
      };
      countrySelect.addEventListener("change", populateStates);
      populateStates();
    }

    if (phoneInput && window.intlTelInput) {
      const iti = window.intlTelInput(phoneInput, {
        initialCountry: "in",
        preferredCountries: ["in", "us", "ca", "gb"],
        separateDialCode: true,
        nationalMode: false,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js"
      });

      const syncCountry = () => {
        const country = iti.getSelectedCountryData();
        const dial = countryCodeMap[(country.iso2 || "").toUpperCase()]?.dial;
        if (dial) phoneInput.placeholder = `${dial} Enter your phone number`;
      };

      phoneInput.addEventListener("countrychange", syncCountry);
      syncCountry();
    }

    form.addEventListener("submit", async (event) => {
      const scriptUrl = form.dataset.googleScriptUrl;
      if (!scriptUrl) return;

      event.preventDefault();
      if (!form.reportValidity()) return;

      const button = form.querySelector('[type="submit"]');
      const response = form.querySelector("[data-form-response]");
      const originalButtonText = button.textContent;
      button.disabled = true;
      button.textContent = "Submitting...";
      response.hidden = true;

      const selectedCountry = countrySelect?.selectedOptions[0];
      const phone = window.intlTelInput?.getInstance(phoneInput)?.getNumber() || phoneInput?.value || "";
      const payload = {
        name: form.querySelector("#LVSName").value.trim(),
        email: form.querySelector("#LVSEmail").value.trim(),
        phone: phone,
        message: form.querySelector("#LVSMessage").value.trim(),
        preferredDate: form.querySelector("#LVSDate").value,
        preferredTime: form.querySelector("#LVSTime").value,
        country: selectedCountry?.textContent.trim() || "",
        state: stateSelect?.value || "",
        termsAccepted: form.querySelector('[name="contact[Terms Accepted]"]').checked ? "Yes" : "No",
        source: window.location.href
      };

      try {
        await fetch(scriptUrl, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: JSON.stringify(payload)
        });
        form.reset();
        if (stateSelect) stateSelect.innerHTML = '<option value="">Select State</option>';
        response.textContent = "Lead Submit Successfully";
        response.classList.remove("is-error");
        response.hidden = false;
      } catch (error) {
        response.textContent = "Unable to submit your lead. Please try again.";
        response.classList.add("is-error");
        response.hidden = false;
      } finally {
        button.disabled = false;
        button.textContent = originalButtonText;
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
